<template>
  <crud-input ref="input" :field="field" :options="options" v-model="value" />
</template>

<script>
import CrudInput from './CrudInput'

export default {
  props: {
    field: String,
    options: Object,
    value: Object
  },
  components: {
    CrudInput
  },
  methods: {
    isValid () {
      return this.$refs.input.isValid()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CrudFormField.vue?91481cc8